import { render, staticRenderFns } from "./Campaigns.vue?vue&type=template&id=c527b350&scoped=true"
import script from "./Campaigns.vue?vue&type=script&lang=ts"
export * from "./Campaigns.vue?vue&type=script&lang=ts"
import style0 from "./Campaigns.vue?vue&type=style&index=0&id=c527b350&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c527b350",
  null
  
)

export default component.exports